import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "../../FinQ/FinQSection/FinQSection.css";
// import animation from "./path-to-animation.gif"; // Adjust path to your loading animation
import banner4 from "../../../images/cybersecurity banner/JM Financial Fraud Website Banner doc-100.jpg"
import banner1 from "../../../images/cybersecurity banner/JM Cyber Criminal doc 1-100.jpg";
import banner2 from "../../../images/cybersecurity banner/JM Cybersmart Website Banner doc-100.jpg";
import banner3 from "../../../images/cybersecurity banner/JM Downside Risk Website Banner doc-100.jpg";

const CyberSecurity = () => {
  const [autoplay, setAutoplay] = useState(true);
  const sliderRef = useRef(null);

  const staticBanners = [
    {img : banner4},
    { img: banner1 },
    { img: banner2},
    { img: banner3}
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: autoplay,
    autoplaySpeed: 4000,
    beforeChange: (current, next) => {
      if (next === staticBanners.length - 1) {
        setAutoplay(true);
      }
    },
    afterChange: (current) => {
      if (current === 0 && !autoplay) {
        setAutoplay(true);
        if (sliderRef.current) {
          sliderRef.current.slickPlay(); // Manually trigger autoplay
        }
      }
    },
  };

  useEffect(() => {
    if (sliderRef.current && autoplay) {
      sliderRef.current.slickPlay();
    }
  }, [autoplay]);

  return (
     <>
    <div className="parentslide">
      <div className="textcentervertex">
        {/* <img src={animation} alt="Loading" />
        <div className="model_popup">Please Wait...</div> */}
      </div>

      <div>
        {staticBanners.length === 0 ? (
          <h5 className="errormsgComNew">No Data Available</h5>
        ) : (
          <Slider ref={sliderRef} {...settings}>
            {staticBanners.map((banner, index) => (
              <div className="w-100" key={index}>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={banner.link}
                >
                  <img
                    alt={`banner-${index}`}
                    src={banner.img}
                    className="img-fluid mx-auto d-block"
                  />
                </a>
              </div>
            ))}
          </Slider>
        )}
      </div>
     <div className="section-header">
              <h2 style={{marginTop: "35px"}} className="cyberHeading">
                Cyber Security Awareness 
              </h2>
            </div>
    </div>

           
            </>
  );
};

export default CyberSecurity;
